import React, {useState, useEffect, useCallback, useMemo} from "react";

import axios from "axios";
import { getRestIdFromGid } from "@utility/shopify"
import { gql } from "graphql-request";
import { useShopQuery } from "@hooks/use-shop-query.js";

const queryCartNotes = gql`
query CartNotes($country:CountryCode!) @inContext(country: $country){
  cartNotes: metaobjects(first:100, type:"cart_note"){
			edges{
				node{
					name: field(key:"name"){
						value
					}
					content: field(key:"content"){
						value
					}
					rules: field(key:"rules"){
						value
					}
					priority: field(key:"priority"){
						value
					}
          active: field(key:"active"){
						value
					}
          level: field(key:"level"){
						value
					}
    		}
		  }
  }
}`

export const CartContext = React.createContext({
  loading: true
});

export const CartProvider = ({children}) => {

  const variables = { country: Shopify.country }
  const {data:notesData, loading:notesLoading, error} = useShopQuery(queryCartNotes, variables);

  var [cart, setCart] = useState()
  var [loading, setLoading] = useState(true);

  useEffect(()=>{
    getCart();
    window.addEventListener('variant:add', getCart);

    // cleanup this component
    return () => {
      window.removeEventListener('variant:add', getCart);
    };
  }, []);

  const getCart = useCallback(async () => {
    //trigger cart refresh on the theme
    document.dispatchEvent(
      new CustomEvent("cart:refresh")
    );
    setLoading(true);
    const response = await axios.get('/cart.json');
    setCart(response.data);
    setLoading(false);
  }, []);

  const addToCart = useCallback(async (variant) => {
    setLoading(true);
    let formData = {
     'items': [{
      'id': getRestIdFromGid(variant.id),
      'quantity': 1
      }]
    };
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    console.log("add to cart");
    await getCart();
  }, [getCart]);

  const updateCart = useCallback(async (lineKey, targetQuantity) => {
    setLoading(true);
    let formData = {
      id: lineKey,
      quantity: targetQuantity,
    };
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    await getCart();
  }, [getCart]);

  const cartNotes = notesData?.cartNotes;
  const contextValue = useMemo(
    () => ({ loading, cart, getCart, addToCart, updateCart, cartNotes }),
    [loading, cart, getCart, addToCart, updateCart, cartNotes]
  );

  return <CartContext.Provider value={contextValue}>
    {children}
    </CartContext.Provider>;
}
